bugsanddrugs.activeNav = function (id) {
  let els = document.getElementsByClassName('menunav');
  for (let i = 0; i < els.length; i++) {
    els[i].classList.remove('active');
  }
  els = document.getElementById(id);
  els.classList.add('active');
}